import { render, staticRenderFns } from "./OrderReg.vue?vue&type=template&id=099765a4&"
import script from "./OrderReg.vue?vue&type=script&lang=js&"
export * from "./OrderReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports